import type { EventReviewTypes } from '@inspiren-monorepo/virtual-care/api-contracts';

import { Api } from '../../../utility/client';

export const getUnits = async () => {
  const res = await Api.get<EventReviewTypes.Unit[]>('/eventReview/v1/units');
  return res.data;
};
